import dayjs from "dayjs";
import { connect } from "react-redux";
import styles from "../CSS/style.less";
import TextComponent from "./TextComponent";
import { MASTER } from "../../../commons/api";
import { constant } from "../Utils/constants";
import SelectComponent from "./SelectComponent";
import React, { useState, useEffect } from "react";
import localStorage from "../../../utils/localStorage";
import translation from "../../../commons/translation";
import StyledTable from "../../../commons/styles/table";
import InputNumberComponent from "./InputNumberComponent";
import { SaveOutlined, UploadOutlined, EditOutlined } from "@ant-design/icons";
import {
  Input,
  Upload,
  Tooltip,
  message,
  TimePicker,
  DatePicker,
  Button
} from "antd";

const TableView = (props) => {
  const [columns, setColumns] = useState(props.form?.columns || []);
  const [data, setData] = useState(
    props.form?.datasource
      ? props.form.datasource.map((dataSource, index) => ({
        ...dataSource,
        key: index + 1,
      }))
      : []
  );
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(true);
  const [translationCache, setTranslationCache] = useState(
    props.translationCache || []
  );

  useEffect(() => {
    const generatedColumns = generateColumns(props.form?.columns || []);
    setColumns(generatedColumns);
    setData(
      props.form?.datasource
        ? props.form.datasource.map((dataSource, index) => ({
          ...dataSource,
          key: index + 1,
        }))
        : []
    );
  }, [props.form]);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache]);

  const generateColumns = (columns) => {
    let finalColumns = [];
    if (columns && columns.length > 0) {
      finalColumns = columns.map((column) => ({
        title: translation(translationCache, column.title),
        dataIndex: column.key || 0,
        key: column.key || 0,
        width: column.width,
        widget: column.widget,
        required: column.required,
        table: column.table || {},
        render: (text, record) => {
          if (record.editable) {
            return renderWidget(column, text, record, columns);
          }

          if (Array.isArray(text)) {
            return text.map((file, index) => (
              <div key={index}>
                <a href={file.url}>{file.name}</a>
              </div>
            ));
          } else if (column.widget === "timePicker") {
            return text;
          } else if (column.widget === "TimePicker") {
            return dayjs(text).format("HH:mm");
          } else if (column.widget === "datePicker") {
            return dayjs(text).format("YYYY-MM-DD");
          } else if (column.key === "name") {
            return (
              <div>
                <a style={{ color: "#062d57" }} href={record.base64}>
                  {text}
                </a>
              </div>
            );
          } else if (column.key === "InspectionId") {
            return (
              <div>
                <TextComponent {...{ column, text, record, columns }} />
              </div>
            );
          } else {
            return text && text !== "null" ? text : "";
          }
        },
      }));
    }
    return finalColumns;
  };

  const onFileChange = (info, column, text, record) => {
    if (info.file.status === "done") {
      let fieldValue = [];
      if (text && Array.isArray(text)) {
        fieldValue = [...text, info.file.response];
      } else if (!text) {
        fieldValue = [info.file.response];
      }
      handleFieldChange(fieldValue, column.key, record.key);
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    } else if (info.file.status === "removed") {
      handleFieldChange(info.fileList, column.key, record.key);
    }
  };

  const renderWidget = (column, text, record, columns) => {
    const token = localStorage.get("accessToken");
    let defaultFileList = text && Array.isArray(text) ? text : [];
    const Authorization = "Bearer " + token;
    const renderProps = {
      name: "file",
      action: `${MASTER.FileUpload}`,
      headers: {
        Authorization: Authorization,
      },
      defaultFileList,
    };

    switch (column.widget) {
      case "input":
        return (
          <Input
            autoFocus
            value={text && text !== "null" ? text : ""}
            style={{ fontWeight: "bold" }}
            onChange={(e) =>
              handleFieldChange(e.target.value, column.key, record.key)
            }
            maxLength={columns?.maxLength || 100000}
            onKeyPress={(e) => handleKeyPress(e.target.value, record.key)}
            placeholder={column.placeHolder || column.displayName}
            disabled={column.disable || false}
          />
        );
      case "inputNumber":
        return column.widgetCondition &&
          column.widgetCondition === true &&
          record.widget !== undefined &&
          record.widget !== true ? (
          <InputNumberComponent value="" disabled style={{ width: "90%", fontWeight: "bold" }} />
        ) : (
          <InputNumberComponent
            value={text && text !== "null" ? text : ""}
            style={{ width: "90%", fontWeight: "bold" }}
            min={column.min !== undefined ? column.min : 0}
            max={column.max !== undefined ? column.max : 1000000}
            onChange={(e) =>
              inputNumberChange(column.min, column.max, e, column.key, record.key)
            }
            placeholder={column.placeHolder || column.displayName}
          />
        );
      case "select":
        return (
          <SelectComponent
            data={data}
            column={column}
            record={record}
            text={text}
            handleFieldChange={handleFieldChange}
            handleKeyPress={handleKeyPress}
          />
        );
      case "upload":
        return (
          <Upload
            {...renderProps}
            onChange={(info) => onFileChange(info, column, text, record)}
          >
            <Button type="primary">
              <UploadOutlined /> Upload
            </Button>
          </Upload>
        );
      case "timePicker":
        return (
          <TimePicker
            format="HH:mm:ss"
            value={text && text !== "Invalid date" ? dayjs(text, "HH:mm:ss") : undefined}
            style={{ width: 300 }}
            disabled={columns.disable || false}
            onChange={(e) => handleFieldChange(e, column.key, record.key)}
            onOpenChange={() => setOpen(true)}
            open={open}
            addon={() => (
              <Button  type="primary" onClick={() => setOpen(false)}>
                Ok
              </Button>
            )}
          />
        );
      case "TimePicker":
        return (
          <TimePicker
            format="HH:mm"
            value={text && text !== "Invalid date" ? dayjs(text, "HH:mm") : undefined}
            style={{ width: 300 }}
            disabled={columns.disable || false}
            onChange={(e) => handleFieldChange(e, column.key, record.key)}
          />
        );
      case "datePicker":
        return (
          <DatePicker
            format="YYYY-MM-DD"
            value={text && text !== "Invalid date" ? dayjs(text, "YYYY-MM-DD") : undefined}
            style={{ width: 300 }}
            disabled={
              column.dataIndex === "EffectiveEndDate" && !record.EffectiveStartDate
            }
            onChange={(e) => handleFieldChange(e, column.key, record.key)}
            disabledDate={(current) => {
              if (column.dataIndex === "EffectiveEndDate") {
                return (
                  !current ||
                  current.isBefore(
                    record.EffectiveStartDate
                      ? dayjs(record.EffectiveStartDate).format("YYYY-MM-DD")
                      : ""
                  )
                );
              } else if (column.dataIndex === "EffectiveStartDate") {
                return (
                  dayjs() >= current ||
                  current.isAfter(
                    record.EffectiveEndDate
                      ? dayjs(record.EffectiveEndDate).format("YYYY-MM-DD")
                      : ""
                  )
                );
              } else {
                return false;
              }
            }}
            addon={() => (
              <Button  type="primary" onClick={() => setOpen(false)}>
                Ok
              </Button>
            )}
          />
        );
      default:
        return text;
    }
  };

  const saveRow = (e, key, record) => {
    e.persist();
    const target = getRowByKey(key) || {};
    let checkReqField = false;

    columns.forEach((columnsObject) => {
      if (columnsObject.required) {
        if (
          target[columnsObject.key] ||
          (target[columnsObject.key] === 0 && target[columnsObject.key] !== "") ||
          (record && record.widget === false)
        ) {
          return;
        } else {
          e.target.focus();
          checkReqField = true;
        }
      }
    });

    if (checkReqField) {
      setSaved(false);
      message.warning("Please fill in the complete information");
    } else {
      saveToggleEditable(e, key);
      setSaved(true);
    }
  };

  const addRow = () => {
    let newdata = {
      key: data.length + 1,
      editable: true,
    };
    columns && Array.isArray(columns) && columns.map((columnData) => {
      if (columnData.key === 'Task') {
        let maxTask =
          data && Array.isArray(data) && data.length > 0
            ? Math.max.apply(
              Math,
              data.map(function (o) {
                return o.Task;
              })
            )
            : 0;
        newdata[columnData.key] = maxTask + 10;
      } else {
        newdata[columnData.key] = '';
      }
      return {};
    });
    data.push(newdata);

    setData(data);
    props.saveTableViewData(data);
  };

  const editRow = (key) => {
    toggleEditable(key);
    setSaved(false);
  };

  const getRowByKey = (key, newData) => {
    return (newData || data).filter((item) => item.key === key)[0];
  };

  const saveToggleEditable = (e, key) => {
    e.preventDefault();
    const newData = data.map((item) => ({ ...item }));
    const target = getRowByKey(key, newData);
    if (target) {
      target.editable = !target.editable;
      setData(newData);
      props.saveTableViewData(newData);
    }
  };

  const toggleEditable = (key) => {
    const newData = data.map((item) => ({ ...item }));
    const target = getRowByKey(key, newData);
    if (target) {
      target.editable = !target.editable;
      setData(newData);
      props.saveTableViewData(newData);
    }
  };

  const handleKeyPress = (e, key, type) => {
    const isInteger = /^[0-9]+$/;
    if (type === "number") {
      if (e === "" || isInteger.test(parseInt(e))) {
        return null;
      } else {
        message.error("Please Input Numbers Only");
      }
    } else {
      if (e.key === "Enter") {
        saveRow(e, key);
      }
    }
  };

  const inputNumberChange = (minValue, maxValue, value, key, record) => {
    if (
      value >= minValue &&
      value <= maxValue &&
      minValue !== undefined &&
      maxValue !== undefined
    ) {
      handleFieldChange(value, key, record);
    } else if (minValue === undefined && maxValue === undefined) {
      handleFieldChange(value, key, record);
    } else {
      handleFieldChange("", key, record);
      message.error(`The input range must be between ${minValue} and ${maxValue}`);
    }
  };

  const handleFieldChange = async (fieldValue, fieldName, keyValue) => {
    const newData = data.map((item) => ({ ...item }));
    let target = getRowByKey(keyValue, newData);
    if (target) {
      if (fieldName === "InspectionId") {
        let selectedItem = props.autoPopulateData.filter((item) => item.Id === fieldValue);
        target[fieldName] = fieldValue;
        target["Description"] = selectedItem[0]?.Description || null;
      } else if (fieldName === "StartTime") {
        target[fieldName] = dayjs(fieldValue).format("HH:mm:ss");
      } else if (fieldName === "EffectiveStartDate" || fieldName === "EffectiveEndDate") {
        target[fieldName] = dayjs(fieldValue).format("YYYY-MM-DD HH:mm:ss");
      } else {
        target[fieldName] = fieldValue;
      }
      setData(newData);
      props.saveTableViewData(newData);
    }
  };

  const renderActionButtons = (record) => {
    return (
      <span>
        {record.editable ? (
          <Tooltip title="Save">
            <Button
              type="primary"
              className="link-button"
              onClick={(e) => saveRow(e, record.key, record)}
            >
              <SaveOutlined />
            </Button>
          </Tooltip>
        ) : (
          <Tooltip title="Edit">
            <Button
              type="primary"
              className="link-button"
              onClick={() => editRow(record.key)}
            >
              <EditOutlined />
            </Button>
          </Tooltip>
        )}
      </span>
    );
  };

  const finalColumns = [
    ...columns,
    {
      title: translation(translationCache, "Action"),
      key: "action",
      render: (text, record) => renderActionButtons(record),
    },
  ];

  return (
    <div className="tableView">
      <StyledTable size="small"
        loading={props.loading}
        columns={finalColumns}
        dataSource={data}
        pagination={{ pageSize: 5 }}
        // style={{ marginTop: "10px", border: "1px solid red !important" }}
        rowClassName={(record) => (record.editable ? styles.editable : "")}
        bordered
      />
      {props.showAddButton && saved && (
        <Button
          type="primary"
          style={{ marginTop: "10px" }}
          onClick={addRow}
        >
          {translation(translationCache, constant.addRow)}
        </Button>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
});

export default connect(mapStateToProps)(TableView);